import { DefaultInfiniteList } from "../../../../-components/InfiniteList"
import { DefaultListItem } from "../../../../-components/default-list/list-item"
import { useTranslation } from "react-i18next"
import { ResourceCard } from "./ResourceCard"
import {
  ResourceObjectDto,
  ResourceObjectDtoPagination,
} from "@/orval/gen/model"
import { UseInfiniteQueryResult, InfiniteData } from "@tanstack/react-query"
import { useGetConditionsByResourceId } from "@/orval/gen"

interface Props {
  queryResult: UseInfiniteQueryResult<
    InfiniteData<ResourceObjectDtoPagination, unknown>,
    Error
  >
  onClickItem?: (item: ResourceObjectDto) => void
}

export function ResourceObjectsCardList({ queryResult, onClickItem }: Props) {
  const { t } = useTranslation("app_server")

  const entities =
    queryResult.data?.pages.flatMap((p) => p?.data ?? []) ??
    ([] as ResourceObjectDto[])

  const uniqueResourceIds = React.useMemo(
    () => Array.from(new Set(entities.map((e) => e.resourceId))),
    [entities]
  )

  const conditionsByResource = React.useMemo(() => {
    const map = new Map<number, Map<number, string>>()
    return map
  }, [])

  return (
    <DefaultInfiniteList
      w={"100%"}
      justify="flex-start"
      queryResult={queryResult}
      renderItem={({ entity }) => {
        const { data: conditions = [] } = useGetConditionsByResourceId({
          resourceId: entity.resourceId,
        })

        const conditionMap = React.useMemo(
          () =>
            new Map<number, string>(
              conditions.map((c: any) => [
                c.resourceObjectConditionId,
                (c.name as string) ?? "-",
              ])
            ),
          [conditions]
        )

        return (
          <DefaultListItem
            maw={"100%"}
            style={{ flex: "1 0 300px", minWidth: 0 }}
            onClick={() => onClickItem?.(entity)}
          >
            <ResourceCard
              title={[entity.name, entity.type].filter(Boolean).join(" / ")}
              attachments={entity.attachments}
              resourceId={entity.resourceId}
              defaultFields={[
                {
                  label: t("Condition"),
                  value:
                    (entity as any).resourceObjectConditionId != null
                      ? (conditionMap.get(
                          (entity as any).resourceObjectConditionId
                        ) ?? "-")
                      : "-",
                },
                {
                  label: t("InventoryNumber"),
                  value: entity.identificationCode,
                },
              ]}
              fieldData={entity.resourceFields.concat(entity.objectFields)}
            />
          </DefaultListItem>
        )
      }}
      direction={"row"}
      wrap={"wrap"}
    />
  )
}
